import { DataDimension, DataPoint } from "shared/request/myHealthyAdvantageApi";

export const roundMinutes = (value?: number) =>
  value != null ? Math.round(value / 60) : value;

export const transformValueItem = (dataPoint: DataPoint) => ({
  ...dataPoint,
  value: roundMinutes(dataPoint.value),
});

export const transformDimension: (dimension: DataDimension) => DataDimension = (dimension: DataDimension) => ({
  ...dimension,
  value: dimension.value?.map(transformValueItem),
});